import VueI18n from "vue-i18n";
import Vue from "vue";
import tr from "./index.tr.json";
import en from "./index.en.json";
import ru from "./index.ru.json";
import de from "./index.de.json";
import fr from "./index.fr.json";
import es from "./index.es.json";
import ar from "./index.ar.json";
import it from "./index.it.json";

Vue.use(VueI18n);

const messages = {
    tr: tr,
    en: en,
    ru: ru,
    de: de,
    fr: fr,
    es: es,
    ar: ar,
    it: it,
};

export const langResources = messages;
// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: "en", // set locale
    fallbackLocale: "tr",
    messages, // set locale messages
});
